import currencyFormatter from 'currency-formatter';

export const validateNameYourPrice =
  ({t, minPrice, maxPrice, currency, entityType}) =>
  ({price}) => {
    if (!price && price !== 0) {
      return {
        price: t('mgw.nameYourPriceRequired'),
      };
    }
    price = Number(price);
    const priceErrors = {
      album: {
        min: 'mgw.nameYourPriceAlbumMinError',
        max: 'mgw.nameYourPriceAlbumMaxError',
      },
      single: {
        min: 'mgw.nameYourPriceSingleMinError',
        max: 'mgw.nameYourPriceSingleMaxError',
      },
      track: {
        min: 'mgw.nameYourPriceTrackMinError',
        max: 'mgw.nameYourPriceTrackMaxError',
      },
    };
    const formatPrice = (price) => currencyFormatter.format(price, {code: currency});

    const processingLimit = 1;
    if (minPrice === 0) {
      if (price !== 0 && price < processingLimit) {
        return {
          price: t('mgw.nameYourPriceFreeMinError', {minPrice: formatPrice(processingLimit)}),
        };
      }
    } else {
      const minPriceProcessed = Math.max(minPrice, processingLimit);
      if (price < minPriceProcessed) {
        return {
          price: t(priceErrors[entityType].min, {minPrice: formatPrice(minPriceProcessed)}),
        };
      }
    }
    if (price > maxPrice) {
      return {
        price: t(priceErrors[entityType].max, {maxPrice: formatPrice(maxPrice)}),
      };
    }
    return {};
  };
